import api from './axios'

/**
 * Login user
 * @param {string} email
 * @param {string} password
 * @returns {Promise<{user: object, token: string}>}
 */
export const login = async (email, password) => {
  const response = await api.post('/auth/login', { email, password })
  return response.data
}

/**
 * Get current user
 * @returns {Promise<object>}
 */
export const getMe = async () => {
  const response = await api.get('/auth/me')
  return response.data
}

/**
 * Logout user
 * @returns {Promise<void>}
 */
export const logout = async () => {
  const response = await api.post('/auth/logout')
  return response.data
}

/**
 * Register new user
 * @param {object} userData
 * @returns {Promise<object>}
 */
export const register = async (userData) => {
  const response = await api.post('/auth/register', userData)
  return response.data
}

/**
 * Change password
 * @param {string} currentPassword
 * @param {string} newPassword
 * @returns {Promise<object>}
 */
export const changePassword = async (currentPassword, newPassword) => {
  const response = await api.post('/auth/change-password', {
    current_password: currentPassword,
    new_password: newPassword
  })
  return response.data
}

/**
 * Request password reset
 * @param {string} email
 * @returns {Promise<object>}
 */
export const requestPasswordReset = async (email) => {
  const response = await api.post('/auth/forgot-password', { email })
  return response.data
}

/**
 * Verify reset token
 * @param {string} token
 * @returns {Promise<object>}
 */
export const verifyResetToken = async (token) => {
  const response = await api.post('/auth/verify-reset-token', { token })
  return response.data
}

/**
 * Reset password with token
 * @param {string} token
 * @param {string} newPassword
 * @returns {Promise<object>}
 */
export const resetPassword = async (token, newPassword) => {
  const response = await api.post('/auth/reset-password', {
    token,
    new_password: newPassword
  })
  return response.data
}

/**
 * Get all users (admin only)
 * @returns {Promise<Array>}
 */
export const getAllUsers = async () => {
  const response = await api.get('/auth/users')
  return response.data
}

/**
 * Create new user (admin only)
 * @param {object} userData
 * @returns {Promise<object>}
 */
export const createUser = async (userData) => {
  const response = await api.post('/auth/users', userData)
  return response.data
}

/**
 * Update user (admin only)
 * @param {number} userId
 * @param {object} userData
 * @returns {Promise<object>}
 */
export const updateUser = async (userId, userData) => {
  const response = await api.put(`/auth/users/${userId}`, userData)
  return response.data
}

/**
 * Delete user (admin only)
 * @param {number} userId
 * @returns {Promise<object>}
 */
export const deleteUser = async (userId) => {
  const response = await api.delete(`/auth/users/${userId}`)
  return response.data
}

/**
 * Force password reset for user (admin only)
 * @param {number} userId
 * @returns {Promise<object>}
 */
export const forcePasswordReset = async (userId) => {
  const response = await api.post(`/auth/users/${userId}/force-reset`)
  return response.data
}